import { call, put } from 'redux-saga/effects';
import DeleteImageFromGoalActions from '../redux/DeleteImageFromGoalRedux';
import { api } from './api';

export function* deleteimagefromgoalsagas(action: any): Generator<any, void, any> {
  const { id, imageId } = action;
  const response = yield call(api.deleteImageFromGoal, id, imageId);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(DeleteImageFromGoalActions.deleteImageFromGoalSuccess(response.data));
  } else {
    yield put(DeleteImageFromGoalActions.deleteImageFromGoalFailure());
  }
}